export default "__VITE_ASSET__DFLsg92G__"